import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/index/index'
import recruit from '../views/recruit/index'
import recruitDetail from '../views/recruit/detail'
import contactUs from '../views/contactUs/index'
import news from '../views/news/index'
import newsList from '../views/news/list'
import newsDetail from "../views/news/detail"
import bussiness from "../views/bussiness/index"
import organizational from "../views/organizational/index"
import overview from "../views/overview/index"
import search from "../views/index/search.vue"
Vue.use(Router)
//路由
export const routes = [
  {
    path: '/',
    component:Home,
    name:'home'
  },
  {
    path: '/recruit',
    component:recruit,
    name:'recruit'
  },{
    path: '/recruitDetail',
    component:recruitDetail,
    name:'recruit'
  },{
    path:'/contactUs',
    component:contactUs,
    name:'contactUs'
  },{
    path:'/news',
    component:news,
    name:'news'
  },{
    path:'/newsList',
    component:newsList,
    name:'news'
  },{
    path:'/newsDetail',
    component:newsDetail,
    name:'news'
  },{
    path:'/bussiness',
    component:bussiness,
    name:'bussiness'
  },{
    path:'/organizational',
    component:organizational,
    name:'orga'
  },{
    path:'/overview',
    component:overview,
    name:'overview'
  },{
    path:'/search',
    component:search,
    name:'search'
  }
]

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes
})
